import {FormItemDataModel} from './form-item-data.model';

export class FormItemRowModel {
  index: number;
  items: FormItemDataModel[] = [];
}
